module.exports = __webpack_public_path__ + "img/download.6f1377af.svg";